var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2067_22604",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#384663"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2067_22604)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#2E3A54"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 5.46436,
    x2: 40,
    y2: 5.46436,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 11.1787,
    x2: 40,
    y2: 11.1787,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 16.8931,
    x2: 40,
    y2: 16.8931,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 22.6072,
    x2: 40,
    y2: 22.6072,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 28.3213,
    x2: 40,
    y2: 28.3213,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.96868e-9,
    y1: 34.0356,
    x2: 40,
    y2: 34.0356,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.96868e-9,
    y1: 39.75,
    x2: 40,
    y2: 39.75,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.3826,
    y: 24.938,
    width: 1.98207,
    height: 1.91473,
    fill: "#FFEFB5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.3824,
    y: 26.8528,
    width: 1.98207,
    height: 2.37891,
    fill: "#F7C39D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.3824,
    y: 29.2319,
    width: 1.98207,
    height: 4.58375,
    fill: "#EE9EC6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.7365,
    y: 5.99805,
    width: 1.98207,
    height: 5.99948,
    fill: "#FFEFB5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.7365,
    y: 11.998,
    width: 1.98207,
    height: 7.4539,
    fill: "#F7C39D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.7365,
    y: 19.4526,
    width: 1.98221,
    height: 14.3635,
    fill: "#EE9EC6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.32031,
    y: 10.1414,
    width: 1.98207,
    height: 5.10594,
    fill: "#FFEFB5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.32031,
    y: 15.2478,
    width: 1.98207,
    height: 6.34375,
    fill: "#F7C39D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.32031,
    y: 21.5918,
    width: 1.98207,
    height: 12.2233,
    fill: "#EE9EC6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6744,
    y: 5.99805,
    width: 1.98207,
    height: 5.99948,
    fill: "#FFEFB5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6744,
    y: 11.998,
    width: 1.98207,
    height: 7.4539,
    fill: "#F7C39D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6744,
    y: 19.4526,
    width: 1.98221,
    height: 14.3635,
    fill: "#EE9EC6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0284,
    y: 9.35205,
    width: 1.98207,
    height: 5.27614,
    fill: "#FFEFB5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0284,
    y: 14.6287,
    width: 1.98207,
    height: 6.55521,
    fill: "#F7C39D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0284,
    y: 21.1841,
    width: 1.98207,
    height: 12.6308,
    fill: "#EE9EC6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherChart);
export default __webpack_public_path__ + "static/media/other-chart.cf8fda7d.svg";
export { ForwardRef as ReactComponent };